export default __webpack_public_path__ + "static/media/moldura-1-NOVO-site.46006059.mp4";